/**
 * 本地持久化存储
 *
 * @public
 */
class LocalPersistStorage {
    constructor(prefix = 'badge-service') {
        this.prefix = prefix;
    }
    /**
     * 设置当前key前缀，例如用户名
     * @param prefix - 前缀内容
     */
    setPrefix(prefix) {
        this.prefix = prefix;
    }
    setRemoved(info) {
        var _a;
        try {
            const storageKey = `${this.prefix}:badge-removed`;
            const removedKeys = JSON.parse((_a = localStorage.getItem(storageKey)) !== null && _a !== void 0 ? _a : '[]');
            const badgeKey = `${info.position}-${info.key}:v${info.version}`;
            removedKeys.push(badgeKey);
            localStorage.setItem(storageKey, JSON.stringify([...new Set(removedKeys)]));
        }
        catch (e) {
            console.error(`Failed to set persist storage:\n${e}`);
        }
    }
    isRemoved(info) {
        var _a;
        try {
            const storageKey = `${this.prefix}:badge-removed`;
            const removedKeys = JSON.parse((_a = localStorage.getItem(storageKey)) !== null && _a !== void 0 ? _a : '[]');
            const badgeKey = `${info.position}-${info.key}:v${info.version}`;
            if (removedKeys.includes(badgeKey)) {
                return true;
            }
        }
        catch (e) {
            console.error(`Failed to set persist storage:\n${e}`);
        }
        return false;
    }
}

export { LocalPersistStorage };
//# sourceMappingURL=local-persist-storage.js.map
